<div class="payment-container">
  <app-my-profit></app-my-profit>
  <app-payment-table></app-payment-table>
</div>
